export default __webpack_public_path__ + "static/media/tj.c92bef0b.jpg";